import { useContext, useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import RemoteLayout from "./layout";
import { Conference } from "../../components/videoCalling";
import { getNextRoute, getPreviousRoute } from "../../util/general.util";
import { WorkshopContext } from "../../contexts/workshop.context";
import { defaultRoles } from "../../util/workshop.util";
import { SpeakingOrder } from "../../components/workshop";

const TASK_ORDER = 0;

const Task1 = () => {
  const { t } = useTranslation();

  const [taskOrderUsers, setTaskOrderUsers] = useState([]);

  const {
    socket,
    user: { role } = {},
    workshopDetails: { platform } = {}
  } = useContext(WorkshopContext);

  const handleNext = () => {
    const nextRoute = getNextRoute("/task-1", platform);
    socket.emit("navigate", nextRoute);
  };

  const handleBack = () => {
    const previousRoute = getPreviousRoute(`/task-1`, platform);
    console.log("previousRoute", previousRoute);

    socket?.emit("navigate", previousRoute);
  };

  useEffect(() => {
    socket.emit("taskOrder", TASK_ORDER, (users) => {
      if (users) setTaskOrderUsers(users);
    });
  }, []);

  return (
    <RemoteLayout
      buttonText={t("task1.button") + " →"}
      onButtonClick={role !== defaultRoles.participant ? handleNext : null}
      showParticipants={true}
      onBackClick={role !== defaultRoles.participant && handleBack}>
      <div className="text-center mb-8">
        <h1 className="text-white text-2xl md:text-4xl flex items-center justify-center gap-2 text-white-100 font-bold">
          <span className="text-yellow-500">🏆</span> {t("task1.heading")}
        </h1>
        <p className="mt-4 max-w-2xl text-lg mx-auto text-white-100">{t("task1.subheading")}</p>
      </div>
      <div className="flex justify-center items-center mb-8">
        <SpeakingOrder participants={taskOrderUsers} filterOnlineParticipants={true} />
      </div>

      {/* Main Content */}
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4 mb-12 w-full">
        {/* Task Overview Card */}
        <div className="flex items-center justify-center w-full h-full">
          <div className="bg-orange-50 rounded-2xl h-fit px-6 py-10 w-full md:col-span-1">
            <h2 className="text-orange-default font-bold text-xl mb-4">
              {t("task1.overview.subheading")}:
            </h2>
            <ul
              className="space-y-4"
              dangerouslySetInnerHTML={{ __html: t("task1.overview.instruction1") }}
            />
          </div>
        </div>

        <div className="col-span-1 md:col-span-2">
          <Conference smallSpace={true} />
        </div>
      </div>
    </RemoteLayout>
  );
};

export default Task1;
